<template>
  <v-dialog v-model="isOpenDialog" max-width="550px">
    <v-card>
      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Importar Registro
          </v-card-title>
        </v-img>
      </v-card-title>
      <v-card-text>
        <v-file-input
          v-model="fileInput"
          truncate-length="15"
          prepend-icon=""
          prepend-inner-icon="mdi-paperclip"
          filled
          rounded
        ></v-file-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="danger" @click="closeDialog" text rounded>
          Cancelar
        </v-btn>
        <v-btn color="success" class="px-5" @click="submitForm" large rounded>
          Cargar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    isOpenDialog: { type: Boolean, required: true },
    campaignId: { type: Number, required: true },
  },
  data() {
    return {
      fileInput: null,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
    async submitForm() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      try {
        const payload = new FormData();
        payload.append("file", this.fileInput);
        payload.append("campaign_id", this.campaignId);
        const res = await PbxHttpClient.post(`/campaign/excel_import`, payload);
        this.$snotify.success("Archivo importado con éxito.", "¡Hecho!");
        this.closeDialog();
      } catch (error) {
        // console.log(error);
        this.$snotify.error("Hubo un error cargando los registros.", "¡Error!");
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },
  },
};
</script>

<style></style>
